import { render, staticRenderFns } from "./DonutChart47.vue?vue&type=template&id=3edc1498&scoped=true&"
import script from "./DonutChart47.vue?vue&type=script&lang=js&"
export * from "./DonutChart47.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc1498",
  null
  
)

export default component.exports